@if (hasPermissionSeybuch) {
  <cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      {{ "Kuhrechte" | translate }}
    </span>
    <ng-container class="cap-table-wrapper-content">
      <cap-list-loader
        [hasRight]="hasPermissionSeybuch && hasRight"
        [listLoader]="listLoader"
        [showTotal]="false"
        [showZeilenSelect]="false">
        <div class="cap-list-loader-content">
          <table class="cap-table-detail">
            <tbody>
              <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
            </tbody>
          </table>
        </div>
      </cap-list-loader>
      <ng-template #tableRows>
        @for (kuhrecht of listLoader?.items; track kuhrecht) {
          @for (version of kuhrecht.versions; track version) {
            <tr>
              <td>
                <span [capHistinfo]="version.histInfo">
                  {{ version.ganzeZahl }}
                  @if (version.bruchteil) {
                    <span> {{ version.bruchteil?.zaehler }}/{{ version.bruchteil?.nenner }} </span>
                  }
                </span>
                @if (anzeigenHistorischeDaten) {
                  <cap-kompakt-timepoint [item]="version.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
                }
              </td>
            </tr>
          }
        }
      </ng-template>
    </ng-container>
  </cap-beschreibung-table-wrapper>
}
